interface ToggleProps {
  leftLabel?: string
  rightLabel: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  id?: string
  'aria-label'?: string
  uncheckedTrackClassName?: string
}

export function Toggle({
  leftLabel,
  rightLabel,
  checked,
  onCheckedChange,
  id,
  'aria-label': ariaLabel,
  uncheckedTrackClassName,
}: ToggleProps) {
  const handleToggle = () => {
    onCheckedChange(!checked)
  }

  const trackBgClass = checked ? 'bg-primary' : (uncheckedTrackClassName ?? 'bg-primary')

  return (
    <div className="flex items-center gap-4">
      {leftLabel != null && leftLabel !== '' && (
        <span className="text-base font-medium text-black">{leftLabel}</span>
      )}
      <button
        id={id}
        type="button"
        onClick={handleToggle}
        className={`${trackBgClass} focus:ring-primary relative inline-flex h-6 w-11 cursor-pointer items-center rounded-full transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-none`}
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel ?? (checked ? rightLabel : (leftLabel ?? rightLabel))}
      >
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
            checked ? 'translate-x-[22px]' : 'translate-x-0.5'
          }`}
        />
      </button>
      <span className="text-base font-medium text-black">{rightLabel}</span>
    </div>
  )
}
